import { Theme, useMediaQuery } from '@mui/material';

import { MOBILE_BREAK_POINT } from 'pages/landing/v2/Main/constants';

export default function useIsMobile() {
    return useMediaQuery<Theme>((theme) => theme.breakpoints.down(MOBILE_BREAK_POINT), {
        noSsr: true
    });
}
